import React from 'react';

import {
  LookupStepInfo,
  LookupStepType,
  TaskFinderProcessTasksLookupStepSpec,
} from 'lookup-config/LookupConfigModalConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {Schema} from 'schemas/SchemaConstants';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

interface ProcessTasksLookupStepDropdownProps {
  processTaskSchema: Schema;
  processTasksStep: LookupStepInfo & {lookupStep: TaskFinderProcessTasksLookupStepSpec};
  onChange: (lookupStep: LookupStepInfo & {lookupStep: TaskFinderProcessTasksLookupStepSpec}) => void;
}

export default function ProcessTasksLookupStepDropdown(
  props: ProcessTasksLookupStepDropdownProps
): JSX.Element {
  const selectedField: SchemaField | null =
    props.processTaskSchema.allFields.find(
      (field) => field.apiId === props.processTasksStep.lookupStep.linkedBySchemaField
    ) ??
    props.processTaskSchema.fields?.[0] ??
    null;

  return (
    <>
      <FieldLabel label="Matching task field" labelStyle={LabelStyle.LABEL} isRequired={true} />
      {selectedField != null ? (
        <SelectDropdown
          displayName={selectedField.displayName}
          menu={
            <Menu width={MenuWidth.FULL} value={selectedField.systemName} scrollable={true}>
              {props.processTaskSchema.fields.map((field: SchemaField) => (
                <Option
                  key={field.systemName}
                  value={field.systemName}
                  onSelect={() => {
                    props.onChange({
                      name: 'Task',
                      lookupStep: {
                        type: LookupStepType.TASK_FINDER_PROCESS_TASKS,
                        linkedBySchemaField: field.apiId,
                      },
                      parentSchema: null,
                      linkSchema: props.processTaskSchema,
                    });
                  }}
                >
                  {field.displayName}
                </Option>
              ))}
            </Menu>
          }
        />
      ) : (
        <span>No fields configured on {props.processTaskSchema.name} schema</span>
      )}
    </>
  );
}
